var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showSearchForm.apply(null, arguments)}}},[_c('img',{attrs:{"src":"/themes/default/img/icons/search.svg","alt":"search","onload":"SVGInject(this);"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }